export enum UserStatus {
  ACTIVE = 'active',
  RESTRICTED = 'restricted',
  PENDING = 'pending',
}
